import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=a74b46a2&scoped=true&"
import script from "./priceIndex.vue?vue&type=script&lang=js&"
export * from "./priceIndex.vue?vue&type=script&lang=js&"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=a74b46a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74b46a2",
  null
  
)

export default component.exports